<div class="container">
  <tpl-loader-spinner class="loader"></tpl-loader-spinner>
  <div class="message">{{ dialogData.message }}</div>
</div>
